import React, { useState, useEffect } from 'react';
import './expensetracker.css';

const ExpenseTrackerChief = () => {
  const [empId, setEmpId] = useState("");  // Employee ID input
  const [selectedEmployee, setSelectedEmployee] = useState({
    empName: "",
    designation: "",
  });
  const [formData, setFormData] = useState({
    category: "",
    amount: "",
    date: "",
    description: "",
  });

  const categories = [
    "Travel Expenses",
    "Office Supplies",
    "Employee Salaries",
    "Utilities (Electricity, Internet, etc.)",
    "Marketing and Advertising",
    "Miscellaneous Expenses",
  ];

  // Fetch employee details based on empId
  const fetchEmployeeDetails = async (empId) => {
    try {
      const response = await fetch(`https://cleezoclass.com:8443/api/employeeProfile/${empId}`);
      if (response.ok) {
        const data = await response.json();
        setSelectedEmployee(data); // Set employee details
      } else {
        console.error('Error fetching employee details:', response.status);
      }
    } catch (error) {
      console.error('Fetch error:', error);
    }
  };

  // Check if the user is authenticated (using local storage or session)
  useEffect(() => {
    const storedEmpId = localStorage.getItem('empId');
    const storedEmpName = localStorage.getItem('empName');
    const storedDesignation = localStorage.getItem('designation');

    if (storedEmpId && storedEmpName && storedDesignation) {
      setSelectedEmployee({
        empName: storedEmpName,
        designation: storedDesignation,
      });
      setEmpId(storedEmpId);
    } else {
      alert('Session expired or employee details not found. Please log in again.');
      window.location.href = '/login'; // Redirect to login if not logged in
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Additional validation
    if (!empId || !selectedEmployee.empName) {
      alert("Please enter a valid Employee ID.");
      return;
    }

    if (!formData.amount || isNaN(formData.amount) || parseFloat(formData.amount) <= 0) {
      alert("Please enter a valid amount greater than 0.");
      return;
    }
    if (new Date(formData.date) > new Date()) {
      alert("Date cannot be in the future.");
      return;
    }

    // Simulate the data submission
    console.log("Form submitted", { empId, ...selectedEmployee, ...formData });

    // Reset form data after submission
    setFormData({ category: "", amount: "", date: "", description: "" });
  };

  return (
    <div className="expense-tracker-container">
      <h1 className="expense-h1">Expense Tracker</h1>
      <form onSubmit={handleSubmit} className="expense-form">
        <div className="form-group">
          <label htmlFor="empId">Employee ID:</label>
          <input
            type="text"
            id="empId"
            name="empId"
            value={empId}
            onChange={(e) => {
              setEmpId(e.target.value);
              if (e.target.value) {
                fetchEmployeeDetails(e.target.value);
              } else {
                setSelectedEmployee({ empName: "", designation: "" });
              }
            }}
            placeholder="Enter Employee ID"
            required
          />
        </div>

        {/* Employee Details Section */}
        <div className="employee-details form-group">
          <div className="form-group">
            <label htmlFor="empName">Employee Name:</label>
            <input
              type="text"
              id="empName"
              name="empName"
              value={selectedEmployee.empName}
              readOnly
              placeholder="Employee Name"
            />
          </div>
          <div className="form-group">
            <label htmlFor="designation">Designation:</label>
            <input
              type="text"
              id="designation"
              name="designation"
              value={selectedEmployee.designation}
              readOnly
              placeholder="Designation"
            />
          </div>
        </div>

        {/* Expense Form Fields */}
        <div className="form-group">
          <label htmlFor="category">Expense Category:</label>
          <select
            id="category"
            name="category"
            value={formData.category}
            onChange={handleInputChange}
            required
          >
            <option value="">Select a category</option>
            {categories.map((cat, index) => (
              <option key={index} value={cat}>
                {cat}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="amount">Amount:</label>
          <input
            type="number"
            id="amount"
            name="amount"
            value={formData.amount}
            onChange={handleInputChange}
            placeholder="Enter amount"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="date">Date:</label>
          <input
            type="date"
            id="date"
            name="date"
            value={formData.date}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="description">Description:</label>
          <textarea
            id="description"
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            rows="4"
            placeholder="Enter description"
          ></textarea>
        </div>

        <div className="form-actions">
          <button type="submit">Add Expense</button>
        </div>
      </form>
    </div>
  );
};

export default ExpenseTrackerChief;
